import React, { Component } from 'react'
import {
	CurrencyEuroIcon,
	ShoppingBagIcon } from '@heroicons/react/outline'

class AncillarySalesCard extends Component {
	_formatEuro = (amount) => {
		const value = Number(amount) || 0
		let txt = value.toFixed(2).replace('.', ',')
		// retire les centimes inutiles (",00")
		if (txt.indexOf(',00') === txt.length - 3)
			txt = txt.substring(0, txt.length - 3)
		return txt + ' €'
	}

	render() {
		if (this.props.loading === true)
		{
			return (
				<div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-5 animate-pulse">
					<div className="h-3 bg-slate-200 rounded-full w-1/3 mb-4"></div>
					<div className="h-8 bg-slate-200 rounded-lg w-1/4 mb-4"></div>
					<div className="h-4 bg-slate-100 rounded w-2/3"></div>
				</div>
			)
		}
		if (this.props.error === true)
		{
			return (
				<div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-5">
					<h2 className="text-2xs font-black text-slate-400 uppercase tracking-widest mt-0 mb-2">Ventes annexes</h2>
					<p className="text-sm font-medium text-slate-500 mt-0 mb-3">Données indisponibles.</p>
					<button
						type="button"
						onClick={this.props.onRetry}
						className="inline-flex items-center px-4 py-2 text-2xs font-black uppercase tracking-widest rounded-xl text-indigo-700 cursor-pointer transition-all active:scale-95 focus:outline-none focus:ring-2 focus:ring-indigo-500"
						style={{ backgroundImage: 'none', backgroundColor: '#eef2ff' }}
					>
						Réessayer
					</button>
				</div>
			)
		}
		const revenue = this.props.revenue7d || 0
		const avgCart = this.props.avgCart || 0
		const topProduct = this.props.topProduct || null
		if (revenue === 0)
		{
			return (
				<div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-5">
					<h2 className="text-2xs font-black text-slate-400 uppercase tracking-widest mt-0 mb-3">Ventes annexes</h2>
					<div className="flex items-center gap-3">
						<div className="w-9 h-9 rounded-xl bg-slate-100 flex items-center justify-center flex-shrink-0">
							<CurrencyEuroIcon className="w-5 h-5 text-slate-400" aria-hidden="true" />
						</div>
						<p className="text-sm font-medium text-slate-500 my-0">Aucune vente sur les 7 derniers jours. Vérifiez que vos produits sont visibles sur l'app.</p>
					</div>
				</div>
			)
		}
		return (
			<div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-5">
				<h2 className="text-2xs font-black text-slate-400 uppercase tracking-widest mt-0 mb-4">Ventes annexes</h2>
				<div className="flex items-center gap-3">
					<div className="w-9 h-9 rounded-xl bg-emerald-50 flex items-center justify-center flex-shrink-0">
						<CurrencyEuroIcon className="w-5 h-5 text-emerald-600" aria-hidden="true" />
					</div>
					<div>
						<p className="text-2xl font-black text-slate-900 my-0 leading-none">{this._formatEuro(revenue)}</p>
						<p className="text-2xs font-bold text-slate-400 uppercase tracking-widest mt-1 mb-0">{this.props.periodLabel || 'CA des 7 derniers jours'}</p>
					</div>
				</div>
				<div className="flex flex-wrap gap-x-6 gap-y-2 mt-4 pt-4 border-t border-slate-100">
					<div>
						<p className="text-sm font-black text-slate-900 my-0">{this._formatEuro(avgCart)}</p>
						<p className="text-2xs font-bold text-slate-400 uppercase tracking-widest my-0">Panier moyen</p>
					</div>
					{topProduct &&
						<div className="flex items-center gap-2 min-w-0">
							<ShoppingBagIcon className="w-4 h-4 text-slate-400 flex-shrink-0" aria-hidden="true" />
							<div className="min-w-0">
								<p className="text-sm font-bold text-slate-700 my-0 truncate">{topProduct}</p>
								<p className="text-2xs font-bold text-slate-400 uppercase tracking-widest my-0">Le plus vendu</p>
							</div>
						</div>
					}
				</div>
			</div>
		)
	}
}

export default AncillarySalesCard
